import { render } from "./thread.vue?vue&type=template&id=0f7aae50&scoped=true"
import script from "./thread.vue?vue&type=script&lang=js"
export * from "./thread.vue?vue&type=script&lang=js"

import "./thread.vue?vue&type=style&index=0&id=0f7aae50&scoped=true&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f7aae50"]])

export default __exports__